var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.798,
    height: 14.826,
    viewBox: "0 0 14.798 14.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone_2_",
    "data-name": "phone (2)",
    d: "M15.909,12.35v2.081A1.387,1.387,0,0,1,14.4,15.819a13.729,13.729,0,0,1-5.987-2.13A13.528,13.528,0,0,1,4.247,9.527a13.729,13.729,0,0,1-2.13-6.015A1.387,1.387,0,0,1,3.5,2H5.579A1.387,1.387,0,0,1,6.967,3.193a8.908,8.908,0,0,0,.486,1.949A1.387,1.387,0,0,1,7.14,6.606l-.881.881a11.1,11.1,0,0,0,4.162,4.162l.881-.881a1.387,1.387,0,0,1,1.464-.312,8.907,8.907,0,0,0,1.949.486,1.387,1.387,0,0,1,1.193,1.408Z",
    transform: "translate(-1.611 -1.5)",
    fill: "none",
    stroke: "#1b2430",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.746ac9564ee306dc5a084732b8da42ee.svg";
export { ForwardRef as ReactComponent };